export default __webpack_public_path__ + "static/media/myreview-24.90675502.png";